import { debounce } from 'data/function';
export class FilterAutocompleteWithDropdownController {
    static $inject = ['$rootScope'];
    constructor($rootScope) {
        'ngInject';
        this.$rootScope = $rootScope;
        this.onInputDebouneTimeout = 1000;
        this.inputMinLength = 3;
        this.selectedValue = '';
        this.options = [];
        this.onOpen = () => {
            this.applyButtonDisabled = true;
        };
        this.applyFilter = () => {
            this.$rootScope.$broadcast('ToggleDropdownItem');
            this.handleFilter({ $value: this.selectedValue });
            this.options = this.options.filter(opt => opt.value !== this.selectedValue);
            this.selectedValue = '';
        };
        this.onSelect = (event) => {
            const selectedValue = event.detail?.value;
            this.selectedValue = selectedValue;
            this.applyButtonDisabled = false;
        };
        this.onInput = (event) => {
            const input = event.target;
            if (input.value.length < this.inputMinLength) {
                return;
            }
            this.onInputDebounced(input.value);
        };
        this.getOptionsInternal = async (value) => {
            const options = await this.getOptions({ $value: value });
            this.options = options;
        };
    }
    $onInit() {
        this.onInputDebounced = debounce(this.getOptionsInternal, this.onInputDebouneTimeout);
    }
}
FilterAutocompleteWithDropdownController.$inject = ['$rootScope'];
